
const SignInHeader = () => {
  
  return (
    <div className="flex sticky top-0 z-10 items-center p-4 bg-black text-white w-full">
      <div className="w-40">
        <img
          src="https://www.regent.ch/fileadmin/main/images/logo_white.svg"
          alt="logo"
          width={150}
          height={50}
        
          className="object-contain cursor-pointer"
        />
      </div>
    </div>
  );
};

export default SignInHeader; 